import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import classNames from 'classnames';
import { Feature } from 'config/features';

import { useFeature } from 'hooks/useFeature';
import { QaIdentifier, useQa } from 'hooks/useQa';

import { ReactComponent as IconGlobeOutline } from 'media/svg/globeOutline.svg';

import { CommunicationContext } from 'utility/Provide/Context/PageContext';

import styles from '../../Destination.module.scss';
import { TargetDistance, TopRegion } from '../../types';

import TargetDistanceList from './TargetDistanceList';
import TopRegionList from './TopRegionList';

interface InitialListProps {
    onTopRegionClick?: (entry: TopRegion) => void;
    onEmptyDestinationClick?: (inputText: string) => void;
    onTargetDistanceClick?: (entry: TargetDistance) => void;
    customClassList?: {
        Layer?: string;
    };
}

const InitialList = ({
    onTopRegionClick,
    onEmptyDestinationClick,
    onTargetDistanceClick,
    customClassList,
}: InitialListProps) => {
    const { t } = useTranslation();
    const context = useContext(CommunicationContext);
    const qaAttr = useQa(QaIdentifier.Search_Form_Destination_Layer_Initial);
    const isS1S4MandatoryActive = useFeature(Feature.S1S4Mandatory);
    const topRegions =
        context.components.backendInformationFunc.getData<{
            topRegions?: TopRegion[];
        }>('searchFormDefaults').topRegions ?? [];

    return (
        <div
            className={classNames(
                styles.ScrollContainer,
                styles.ListWrapper,
                customClassList?.Layer
            )}
            {...qaAttr}
        >
            {!isS1S4MandatoryActive && (
                <div
                    onClick={() =>
                        onEmptyDestinationClick?.(t('TRANS-random-destination'))
                    }
                >
                    <ul
                        className={classNames(
                            styles.ResultList,
                            styles.MultiLine
                        )}
                    >
                        <li
                            className={classNames(
                                styles.ListItem,
                                styles.MultiLine,
                                styles.RandomDestination
                            )}
                        >
                            <div className={styles.ListItemContent}>
                                <div className={styles.Icon}>
                                    <IconGlobeOutline />
                                </div>
                                <strong>{t('TRANS-random-destination')}</strong>
                                {t('TRANS-discover-all-holiday-destinations')}
                            </div>
                        </li>
                    </ul>
                </div>
            )}
            <TopRegionList entries={topRegions} onClick={onTopRegionClick} />
            <TargetDistanceList onClick={onTargetDistanceClick} />
        </div>
    );
};

export default InitialList;
